jQuery(document).ready(function($) {
    // Remove second contact page content
    $('.contact-page--content').eq(1).remove();

    // Set default selection for cstm-pro-select and choose-level-of-spiciness
    $('.cstm-pro-select, .choose-level-of-spiciness').each(function() {
        $(this).val($(this).find('option:first').val()); // Select the first option
    });

    // Step 1: Find the maximum height
    var maxHeight = 0;
    $('.product-tab .ap-productlist__inner .product-item__info').each(function() {
        var currentHeight = $(this).height();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });

    // Step 2: Set the maximum height to all elements
    $('.product-tab .ap-productlist__inner .product-item__info').height(maxHeight);

    // NEW CODE: Handle fake/real button toggle and error message on fake button click
    // ==========================================================================
    $('.product-item').each(function() {
        var $item = $(this);
        var $variantSelect = $item.find('.cstm-pro-select');
        var $spiceSelect = $item.find('.choose-level-of-spiciness');
        var $realButtonWrapper = $item.find('.btn-addcart-real');
        var $fakeButtonWrapper = $item.find('.btn-addcart-fake');
        var $fakeButton = $item.find('.btn-addcart-fake button');
        var $errorMessage = $item.find('.select-error');
        var $hiddenSpiceInput = $item.find('.spicelineitem');
        var $hiddenVariantInput = $item.find('.productvariants');

        // Function to update button visibility and hidden inputs
        function updateButtonState() {
            var isVariantValid = true;
            var isSpiceValid = true;

            // Check variant select
            if ($variantSelect.length) {
                isVariantValid = $variantSelect.val() !== '';
                if (isVariantValid && $hiddenVariantInput.length) {
                    $hiddenVariantInput.val($variantSelect.val()); // Update hidden variant input
                }
            }

            // Check spice select
            if ($spiceSelect.length) {
                isSpiceValid = $spiceSelect.val() !== '';
                if (isSpiceValid && $hiddenSpiceInput.length) {
                    $hiddenSpiceInput.val($spiceSelect.val()); // Update hidden spice input
                }
            }

            // Toggle real/fake button visibility
            if (isVariantValid && isSpiceValid) {
                $realButtonWrapper.show();
                $fakeButtonWrapper.hide();
            } else {
                $realButtonWrapper.hide();
                $fakeButtonWrapper.show();
            }

            // Hide error message on select change
            $errorMessage.text('').hide();
        }

        // Handle click on fake button to show error message
        $fakeButton.on('click', function(e) {
            e.preventDefault(); // Prevent any default action
            var errorText = '';
            var isVariantValid = $variantSelect.length ? $variantSelect.val() !== '' : true;
            var isSpiceValid = $spiceSelect.length ? $spiceSelect.val() !== '' : true;

            if ($variantSelect.length && $spiceSelect.length) {
                // Both selects exist
                if (!isVariantValid && !isSpiceValid) {
                    errorText = 'Please select a protein and spice level.';
                } else if (!isVariantValid) {
                    errorText = 'Please select a protein.';
                } else if (!isSpiceValid) {
                    errorText = 'Please select a spice level.';
                }
            } else if ($variantSelect.length && !isVariantValid) {
                // Only variant select exists
                errorText = 'Please select a protein.';
            } else if ($spiceSelect.length && !isSpiceValid) {
                // Only spice select exists
                errorText = 'Please select a spice level.';
            }

            // Show error message
            $errorMessage.text(errorText).show();
        });

        // Bind event listeners (enhance existing change handlers)
        $variantSelect.on('change', function() {
            // Existing logic
            var selectedOption = $(this).find('option:selected');
            var price = selectedOption.attr('price');
            $item.find('.product-item__info--bottom .price').text(price);
            $item.find('.productvariants').val($(this).val());
            $item.find('.choose-level-of-spiciness').val(
                $item.find('.choose-level-of-spiciness option:first').val()
            );
            $item.find('.line-item-property__field .spicelineitem').attr('value', '');

            // New logic: Update button visibility and hide error message
            updateButtonState();
        });

        $spiceSelect.on('change', function() {
            // Existing logic
            var linitem = $(this).val();
            $item.find('.line-item-property__field .spicelineitem').attr('value', linitem);

            // New logic: Update button visibility and hide error message
            updateButtonState();
        });

        // Initial check
        updateButtonState();
    });
    // ==========================================================================

});

// Shipping bar threshold update
setInterval(function() {
    var shippingthreshold = $('.shipping-bar-threshold').attr('threshold');

    $.ajax({
        type: "GET",
        url: '/cart',
        dataType: 'json',
        success: function(response) {
            var value = response.total_price;
            var total = value / 100;  
            var remaining = shippingthreshold - total;
            if (remaining <= 0) {
                $('.shipping-bar__text').text("Congrats! Your order qualifies for free delivery. Enjoy!");
            } else {
                $('.shipping-bar__text').text("You need " + remaining.toFixed(2) + " more to qualify for free delivery.");
            }
        },
        error: function(xhr, status, error) {
            console.error("Error in update", xhr.responseJSON || error);
        }
    });
}, 1000); 

// Preorder code
var selectedIds = [];
var spicinessLevels = [];

$('.selectbutton').click(function () {
    var dataid = $(this).parents('.product-item__info').find('.productvariants').val();
    $(this).toggleClass('selected-item');

    if ($(this).hasClass('selected-item')) {
        selectedIds.push(dataid);
        $(this).text('Remove');
    } else {
        selectedIds = selectedIds.filter(function(id) {
            return id !== dataid;
        });
        $(this).text('Select');
    }

    console.log(selectedIds);
});

var quantity1 = [];

$('.stickyaddcartcstm').click(function () {
    $('.selected-item').each(function () {
        var quantityy = $(this).parents('.product-item__info').find('.quantitiypro').val();
        var spiciness = $(this).parents('.product-item__info').find('.choose-level-of-spiciness').val() || '';
        console.log(quantityy);
        console.log(spiciness);

        quantity1.push(quantityy);
        spicinessLevels.push(spiciness);
    });

    console.log(quantity1);
    console.log(spicinessLevels);

    var items = selectedIds.map(function(id, index) {
        return {
            id: id,  
            quantity: quantity1[index],  
            properties: {
                "Level of Spiciness": spicinessLevels[index] || ''
            }
        };
    });

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            items: items
        },
        success: function (response) {
            console.log('Product added successfully: ', response);
    
            selectedIds = [];
            quantity1 = [];
            spicinessLevels = [];
            $('.selectbutton').removeClass('selected-item').text('Select');

            console.log('Products successfully added to the cart!');
        },
        error: function (xhr, status, error) {
            console.error('Error adding product: ', error);
        }
    });

  

});